import AttachItemsToInvoiceHtml     from '../invoices/templates/attach.items.to.invoice.html';
import VendorInvoiceAcquisitionHtml from '../invoices/vendor-invoice.acquisition.html';
import WindowFlipHtml               from '../../app-lite/core/templates/window-flip.html';

export function PurchaseOrderService (
  $q,
  $state,
  $translate,
  $uibModal,
  confirm,
  jsonApi,
  messages,
  pruneApi,
  sessionObjAPI,
  tableApi,
  workshopAPI
) {
  var Order = function (order) {
    this.form  = {};
    this.order = order;
  };

  Order.prototype.ashdown = function() {
    var self = this;
    var ashdownVendor = sessionObjAPI.company().ashdown_ingram_settings.ashdown_ingram_vendor_id;

    return self.order.vendor_id && sessionObjAPI.company().has_ashdown_ingram && ashdownVendor === self.order.vendor_id;
  };

  Order.prototype.assemble = function (order) {
    order = jsonApi.copy(order);

    order.purchase_order_items_attributes = pruneApi.removeUntouched(order.purchase_order_items_attributes);
    order.purchase_order_items_attributes = order.purchase_order_items_attributes.concat(order.itemsToDelete || []);

    return $q.when(order);
  };

  Order.prototype.attachItemsToInvoice = function (items) {
    const cache = tableApi.getCacheForTable('vendorInvoiceItemsAttach');

    return $uibModal.open({
      templateUrl: AttachItemsToInvoiceHtml,
      windowClass: 'product-search-modal',
      controller : 'AttachItemsToInvoiceCtrl',
      resolve    : {
        invoices: () => workshopAPI.get('/invoices/invoice_list_for_linking', [0, cache.paging.pageSize || 5, 'O', 'I-U', 'job_card_number', 'desc', '*'])
      }
    }).result
    .then(invoice => workshopAPI.post('/invoices/create_invoice_item_from_order_item', {
      invoice_id          : invoice.id,
      purchase_order_items: items.map(item => item.id)
    }));
  };

  Order.prototype.cleanup = function(order) {
    var self = this;
    var deferred = $q.defer();

    self.order = order;

    self.form.$setPristine();

    $state.go('app.purchase-order', {
      acquisition_order_id: null,
      id                  : order.id,
      vendor_id           : order.vendor_id
    }, {
      location: 'replace',
      reload  : true
    });

    deferred.resolve(order);

    return deferred.promise;
  };

  Order.prototype.closed = function() {
    var self = this;

    return self.order.status != 'S';
  };

  Order.prototype.delete = function() {
    var self = this;

    return confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_ORDER') )
      .then(function () {
        return workshopAPI.delete('/purchase_order', self.order.id);
      }).then(function () {
        self.form.$setPristine();
        $state.go('app');

        return;
      });
  };

  Order.prototype.deleteItems = function() {
    var self = this;
    var order = {
      id                             : self.order.id,
      purchase_order_items_attributes: self.order.itemsToDelete
    };

    if (self.order.itemsToDelete.length && self.order.id) {
      return workshopAPI.patch('/purchase_order', order, 'purchase_order')
        .then(function (order) {
          self.order.itemsToDelete = [];
          return order;
        });
    }

    return $q.when(self.order);
  };

  Order.prototype.getCopy = function () {
    var self = this;
    var copy = sessionObjAPI.get('purchase_order_copy');

    if (copy) {
      self.order = copy;
      self.form = {};

      sessionObjAPI.setKey('purchase_order_copy', null);
    }

    return copy ? copy : null;
  };

  Order.prototype.launchAcquisitionModal = function () {
    return $uibModal.open({
      templateUrl      : VendorInvoiceAcquisitionHtml,
      windowClass      : 'product-search-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      controller       : 'AcquisitionCtrl',
      resolve          : {
        bodyTypes: [ 'workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes');
        }],
        driveTypes: [ 'workshopAPI', function(workshopAPI) {
          return workshopAPI.get('/system/drive_types/', null, 'driveTypes');
        }],
        franchises: [ 'workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/vehicle_group_or_franchise_types');
        }],
        fuelTypes: [ 'workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/system/fuel_types/', null, 'fuelTypes');
        }],
        templates: [ 'gridAPI', 'workshopAPI', function (gridAPI, workshopAPI) {
          return workshopAPI.get('/vehicle_templates', [ 0, 11, 'find_description', 'asc' ]);
        }],
        transmissionTypes: [ 'workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/system/transmission_types/', null, 'transmissionTypes');
        }]
      }
    }).result;
  };

  Order.prototype.prolink = function () {
    var self = this;
    var prolinkVendor = sessionObjAPI.company().prolink_settings.prolink_vendor_id;

    return self.order.vendor_id && sessionObjAPI.company().has_prolink && prolinkVendor === self.order.vendor_id;
  };

  Order.prototype.process = function(confirmationMessage) {
    var self = this;
    var confirmSettings = {
      buttons: {
        confirm: {
          class: 'success'
        }
      }
    };

    if (self.repco() && !confirmationMessage) {
      confirmSettings.message = $translate.instant('JS_SPACE.REPCO.ORDER_CANNOT_BE_SENT');
      confirmSettings.type = 'warning';
      confirmSettings.buttons.confirm.title = $translate.instant('GENERAL_SPACE.BUTTON.PROCESS_ANYWAY');

    }
    else {
      confirmSettings.message = confirmationMessage || 'Are you sure you want to save and process this order?';
      confirmSettings.buttons.confirm.title = $translate.instant('GENERAL_SPACE.SWITCH.YES');
    }

    return confirm.custom(confirmSettings).then(function () {
      return self.save();
    }).then(function (order) {
      return workshopAPI.get('/purchase_orders/process_order', order.id, null);
    });
  };

  Order.prototype.repco = function() {
    var self = this;
    var repcoVendor = sessionObjAPI.company().repco_settings.repco_vendor_id;

    return self.order.vendor_id && sessionObjAPI.company().has_repco && repcoVendor === self.order.vendor_id;
  };

  Order.prototype.save = function() {
    const self   = this;
    const url    = self.order.id ? '/purchase_order': '/purchase_orders';
    const method = self.order.id ? 'patch': 'post';

    return self.validate()
    .then(order => self.assemble(order))
    .then(order => workshopAPI[method](url, order, 'purchase_order'))
    .then(order => self.cleanup(order));
  };

  Order.prototype.status = function(status) {
    var self = this;
    var statusMap = {
      suggested: 'S',
      onOrder  : 'O',
      received : 'R'
    };

    if (status === 'actionable') {
      return !self.closed() && self.repco() || self.ashdown() || self.prolink();
    }

    return statusMap[status] == self.order.status;

  };

  Order.prototype.validate = function() {
    const self     = this;
    const deferred = $q.defer();

    if (self.form.$valid) {
      deferred.resolve(self.order);
    }
    else {
      messages.clientError(self.form);
      deferred.reject();
    }

    return deferred.promise;
  };

  return Order;
};